var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuiet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 18",
    style: {
      enableBackground: "new 0 0 21 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#231F20;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.5,9.9c0-0.5-0.39-0.9-0.88-0.9C9.14,9,8.75,9.4,8.75,9.9v0.01c0,0.5,0.39,0.9,0.88,0.9 C10.11,10.81,10.5,10.41,10.5,9.9L10.5,9.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.12,9C13.61,9,14,9.4,14,9.9v0.01c0,0.5-0.39,0.9-0.88,0.9c-0.48,0-0.88-0.4-0.88-0.9V9.9 C12.25,9.4,12.64,9,13.12,9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.5,9.9c0-0.5-0.39-0.9-0.88-0.9c-0.48,0-0.88,0.4-0.88,0.9v0.01c0,0.5,0.39,0.9,0.88,0.9 C17.11,10.81,17.5,10.41,17.5,9.9L17.5,9.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.13,0c1.85,0,3.51,0.84,4.63,2.17C11.5,1.93,12.3,1.8,13.12,1.8C17.47,1.8,21,5.43,21,9.9 c0,1.29-0.3,2.52-0.82,3.61l0.8,3.38c0.07,0.31-0.02,0.63-0.23,0.85c-0.22,0.22-0.53,0.31-0.82,0.24l-3.29-0.82 C15.57,17.7,14.38,18,13.12,18c-3.44,0-6.36-2.26-7.43-5.42c-0.93-0.07-1.8-0.34-2.56-0.79l-1.95,0.75 c-0.32,0.12-0.68,0.04-0.92-0.21s-0.32-0.62-0.2-0.95l0.73-2C0.28,8.47,0,7.42,0,6.3C0,2.82,2.74,0,6.13,0z M1.75,6.3 c0-2.49,1.96-4.5,4.37-4.5c1.13,0,2.16,0.44,2.93,1.16C6.78,4.38,5.25,6.96,5.25,9.9c0,0.28,0.01,0.55,0.04,0.82 c-0.58-0.11-1.11-0.35-1.58-0.67C3.47,9.89,3.18,9.86,2.92,9.96l-0.55,0.21L2.57,9.6c0.1-0.27,0.06-0.57-0.09-0.81 C2.02,8.08,1.75,7.22,1.75,6.3z M10.79,4.07c0.72-0.31,1.51-0.47,2.34-0.47c3.38,0,6.12,2.82,6.12,6.3c0,1.11-0.28,2.15-0.77,3.05 c-0.11,0.2-0.14,0.43-0.09,0.65l0.54,2.28l-2.21-0.55c-0.21-0.05-0.44-0.02-0.63,0.09c-0.88,0.5-1.89,0.79-2.97,0.79 c-2.85,0-5.25-2.01-5.93-4.73C7.07,10.97,7,10.44,7,9.9C7,7.27,8.56,5.02,10.79,4.07z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiet);
export default __webpack_public_path__ + "static/media/quiet.cc26c52162c1d0c1024a1e6c91c42561.svg";
export { ForwardRef as ReactComponent };